import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { FRAGMENT_CUSTOMER_ONBOARDING_EMAIL } from './schema';

const QUERY = gql`
  query CustomerOnboardingEmail($id: ID!) {
    customer(id: $id) {
      id
      onboardingEmail {
        ...CustomerOnboardingEmail
      }
    }
  }
  ${FRAGMENT_CUSTOMER_ONBOARDING_EMAIL}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'id' | 'onboardingEmail'>;

export const queryCustomerOnboardingEmail = async (variables: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<Result>(result.data)?.onboardingEmail;
};
